/* DSL Form pre-fill — laad customer.default_address velden in [data-prefill] forms */
(function(){
  if (!window.DSL_CUSTOMER) return;
  document.querySelectorAll("[data-prefill] input, [data-prefill] select").forEach(function(el){
    var k = el.name.replace(/^.*\[/, "").replace(/\]$/, "");
    var v = window.DSL_CUSTOMER.address && window.DSL_CUSTOMER.address[k];
    if (v && !el.value) el.value = v;
  });
})();